import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthLayout } from '@/features/auth/components/auth-layout/AuthLayout';
import { AcceptInvitationPage } from '@/features/auth/pages/accept-invitation-page/AcceptInvitationPage';

const RouteComponent = () => {
  const { token } = Route.useParams();
  const { email } = Route.useSearch();
  return (
    <AuthLayout>
      <AcceptInvitationPage token={token} email={email} />
    </AuthLayout>
  );
};

export const Route = createFileRoute('/accept-invitation/$token')({
  validateSearch: z.object({
    email: z.string().optional(),
  }),
  component: RouteComponent,
});
